export default "__VITE_ASSET__CMd8JGnI__"